module.exports = __webpack_public_path__ + "img/lsjn2.1a432a19.jpg";